<template>
  <div id="ModalContent">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div id="modal-all">
            <div class="modal-container">
              <div>
                <slot name="body">
                </slot>
                <div class="modal-footer">
                  <slot name="footer">
                  </slot>
                </div>
              </div>
            </div>
            <a id="exit-button" v-on:click="closeModal()">
              <div>
                <h2>X</h2>
              </div>
            </a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>

export default {
  name: "Modal",
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
};
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  height: 80vh;
  width: 80vw;
  overflow: auto;
  padding: 20px 30px;
  background-color: lightseagreen;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  border: 5px solid black;
  border-radius: 20px;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
#modal-all{
  display: flex;
  margin: 0px auto;
  justify-content: center;
}
#exit-button {
  background-color: antiquewhite;
  border: 3px solid black;
  border-radius: 50%;
  color: black;
  width: 40px;
  height: 40px;
  margin-left: -2em;
  font-weight: bolder;
  cursor: pointer;
  z-index: 9999;
}
#exit-button:hover {
  background-color: black;
  border: 3px solid antiquewhite;
  color: antiquewhite;
}

</style>
